import {gql} from "@apollo/client";

export const whoIsIt = gql`
    query whoisit(
        $portfolioKey: Int!){
            whoisit(input: { portfolioKey: $portfolioKey}) {
                portfolio {
                  accountId
                  financialInfo{
                    buyingPower
                    lastHardCheckAt
                    totalValue
                  }
                  connectionStatus
                  accountRestriction
                  accountRestrictionChangedAt
                }
                institution{
                  createdAt
                  institutionKey
                }
            }
        }`;

export const PORTFOLIO_ACCOUNT_RESTRICTION_UPDATE = gql`
    mutation portfolioAccountRestrictionUpdate(
        $portfolioKey: Int!
        $accountRestriction: ACCOUNT_RESTRICTION!
    ) {
        portfolioAccountRestrictionUpdate(input: {
            portfolioKey: $portfolioKey
            accountRestriction: $accountRestriction
        }) {
            portfolio {
                accountRestriction
                accountRestrictionChangedAt
            }
        }
    }
`;

export const PORTFOLIO_ACCOUNT_RESTRICTION_OPTIONS = [
    "UNRESTRICTED",
    "RESTRICTED",
    "RESTRICTED_ONLY_LIQUIDATION",
    "RESTRICTED_WITH_RESOLUTION",
    "UNKNOWN_RESTRICTED",
] as const;

export type PortfolioAccountRestriction = typeof PORTFOLIO_ACCOUNT_RESTRICTION_OPTIONS[number];